var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRutube({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "svg",
    width: 132,
    height: 132,
    fill: "white",
    fillOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 132,
    height: 132
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect",
    rx: 32,
    width: 132,
    height: 132,
    fill: "#000000",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M81.53 62.98L42.53 62.98L42.53 47.55L81.53 47.55C83.81 47.55 85.39 47.95 86.19 48.64C86.98 49.33 87.48 50.62 87.48 52.5L87.48 58.04C87.48 60.02 86.98 61.3 86.19 62C85.39 62.69 83.81 62.98 81.53 62.98ZM84.21 33L26 33L26 99L42.53 99L42.53 77.52L73.01 77.52L87.48 99L106 99L90.05 77.42C95.93 76.55 98.57 74.75 100.75 71.78C102.92 68.81 104.01 64.07 104.01 57.73L104.01 52.78C104.01 49.03 103.62 46.06 102.92 43.78C102.23 41.51 101.04 39.53 99.36 37.75C97.58 36.06 95.6 34.88 93.22 34.09C90.84 33.39 87.87 33 84.21 33Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M198 3.05e-5C198 36.45 168.45 66 132 66C124.58 66 117.46 64.77 110.81 62.52C110.95 60.95 111.01 59.35 111.01 57.73L111.01 52.78C111.01 48.58 110.58 44.88 109.62 41.74C108.59 38.35 106.82 35.44 104.44 32.93L104.31 32.79L104.17 32.66C101.64 30.27 98.76 28.56 95.43 27.45L95.31 27.4L95.18 27.37C92.01 26.44 88.35 26 84.21 26L77.21 26L71.32 26C67.89 18.02 66 9.23 66 3.05e-5C66 -36.46 95.54 -66 132 -66C168.45 -66 198 -36.46 198 3.05e-5Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "rect",
    x: 1,
    y: 1,
    rx: 31,
    width: 130,
    height: 130,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect",
    x: 1,
    y: 1,
    rx: 31,
    width: 130,
    height: 130,
    stroke: "#FFFFFF",
    strokeOpacity: 1,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRutube);
export default __webpack_public_path__ + "static/media/Rutube.da5fdf64adabbece28b93024801f4808.svg";
export { ForwardRef as ReactComponent };